import {useNavigate} from 'react-router-dom';

function PageNotFound() {
    const navigate = useNavigate();

    return (
        <>
            <h1 className="text-center">Page not found</h1>

            <div className="d-flex justify-content-center">
                <a
                    href="#"
                    onClick={(event: React.MouseEvent) => {
                        event.preventDefault();
                        navigate(-1);
                    }}
                    className="btn btn-primary btn-lg"
                >
                    Back
                </a>
            </div>
        </>
    );
}

export default PageNotFound;
